import {Plan, Reserve} from "../common/types/Types";
import React, {SyntheticEvent, useState} from "react";
import ReserveBadge from "./ReserveBadge";

interface PlanViewProps {
    plan: Plan;
    reserves?: Reserve[];
    withLink?: boolean;
}

interface ImgDimensions {
    naturalHeight: number;
    naturalWidth: number;
    height: number;
    width: number;
}

const PlanView = (props: PlanViewProps) => {
    const {plan = {} as Plan, reserves = [], withLink = false} = props;
    const [imgDimensions, setImgDimensions] = useState<ImgDimensions>({} as ImgDimensions);

    const xRatio = imgDimensions.width / imgDimensions.naturalWidth;
    const yRatio = imgDimensions.height / imgDimensions.naturalHeight;

    return <div>
        <h5 className="color-blue">{plan.libPlan} <small>
            {withLink && <b>({reserves.length})</b>}
        </small></h5>
        <div className="">
            <div className="reserves-plan-container">
                <div>
                    {reserves.map((reserve, index) =>
                        <ReserveBadge
                        key={reserve.refReserve || `rb-${index}`}
                        reserve={reserve}
                        withLink={withLink}
                        withPosition={true}
                        yRatio={yRatio}
                        xRatio={xRatio}/>)}

                    <img className="img-plan-200"
                         src={plan.urlPlan}
                         alt={plan.libPlan}
                         onLoad={(e: SyntheticEvent<HTMLImageElement>) => {
                             const target = e.target as HTMLImageElement;
                             setImgDimensions({
                                 naturalHeight: target.naturalHeight,
                                 naturalWidth: target.naturalWidth,
                                 height: target.height,
                                 width: target.width,
                             })
                         }}/>
                </div>
            </div>
        </div>
    </div>;
};

export default PlanView;
